import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettingsDto } from '@interfaces/AppSettingsDto';
import { NGXLogger } from 'ngx-logger';
import { EMPTY, firstValueFrom, Observable, ReplaySubject } from 'rxjs';
import { catchError, take, tap } from 'rxjs/operators';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class AppSettingsService extends BaseService {
  private appSettings$ = new ReplaySubject<AppSettingsDto>(1);

  private isInit = false;

  public constructor(private http: HttpClient, private logger: NGXLogger) {
    super();
  }

  public getAppSettingsAsync() {
    return firstValueFrom(this.getAppSettings().pipe(take(1)));
  }

  public getAppSettings(): Observable<AppSettingsDto> {
    if (!this.isInit) {
      this.isInit = true;
      this.http
        .get<AppSettingsDto>(this.baseUrl + '/web/AppSettings/')
        .pipe(
          tap(x => {
            this.appSettings$.next(x);
          }),
          catchError((err, caught) => {
            this.logger.error('AppSettingsService.geAppSettings() : ', err);
            this.logger.error('AppSettingsService.getAppSettings() : ', caught);
            return EMPTY;
          })
        )
        .subscribe();
    }

    return this.appSettings$.asObservable();
  }
}
